export default {"src":"/_next/static/media/information_details.048cc285.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};